export class DraftsReport {
  all_cost_sum: number = 0;
  all_count: number = 0;
  cancelled_cost_sum: number = 0;
  cancelled_count: number = 0;
}
